export default __webpack_public_path__ + "static/insightVideo-9db536e0c41d7192000bd2f55909850d.svg";